// extracted by mini-css-extract-plugin
module.exports = {"UploadPaper":"style_UploadPaper__2luPz","closeBtn":"style_closeBtn__1vF-F","title":"style_title__8kxj4","template":"style_template__1uNsw"};